import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ADMIN_API, PAGINATION_LIMIT } from '../../common/common'
import { Logout } from '../../common/Funcation'
import { postApi, notifyError } from '../../service'
import { styleObjectBlackButton } from '../../common/StyleSeter'
import InPageLoader from "../InPlageLoader";
import Pagination from "../Pagination";
import { usePagination } from "../../hooks/usePagination";

const PAGE_SIZE = PAGINATION_LIMIT

const startOfDay = (d: Date) => {
    const x = new Date(d)
    x.setHours(0, 0, 0, 0)
    return x
}

const endOfDay = (d: Date) => {
    const x = new Date(d)
    x.setHours(23, 59, 59, 999)
    return x
}

const daysAgo = (n: number) => {
    const x = new Date()
    x.setDate(x.getDate() - n)
    return startOfDay(x)
}

const PRIMARY_TABS = [
    { key: 'exchange', label: 'Exchange' },
    { key: 'fancyBet', label: 'FancyBet' },
    { key: 'fancy1Bet', label: 'FancyBet1' },
    { key: 'toss', label: 'Toss' },
    { key: 'casino', label: 'Casino' },
    { key: 'sportsbook', label: 'Sportsbook' },
    { key: 'bookMaker', label: 'BookMaker' },
    { key: 'bpoker', label: 'BPoker' },
    { key: 'premium', label: 'Premium' },
]

const SECONDARY_TABS = [
    { key: 'other', label: 'Other' },
    { key: 'SABASports', label: 'SABA SPORTS' },
]

const SPORT_FILTERS = [
    { value: 'ALL', label: 'ALL' },
    { value: 'soccer', label: 'SOCCER' },
    { value: 'tennis', label: 'TENNIS' },
    { value: 'cricket', label: 'CRICKET' },
]

function BettingProfitLoss(props: any) {
    const { userId, TYPE } = props
    const profitLossApi = TYPE === 'agent'
        ? ADMIN_API.AGENT_PROFIT_LOSS
        : ADMIN_API.PLAYER_PROFIT_LOSS
    const userData = useSelector((e: any) => e.userData)
    const DD = useSelector((e: any) => e.domainDetails)
    const navigate = useNavigate()
    const [pageData, setPageData] = useState<any>({ rows: [], total: 0, user_name: '', totalPages: 0 })
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    });
    const [endDate, setEndDate] = useState(new Date());
    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };
    const [startTime, setStartTime] = useState("00:00");
    const [endTime, setEndTime] = useState(getCurrentTime);
    const [filterTab, setFilterTab] = useState('date')
    const [currentTab, setCurrentTab] = useState('exchange')
    const [sportFilter, setSportFilter] = useState('ALL')
    const [page, setPage] = useState(1)
    const [openRows, setOpenRows] = useState<string[]>([])
    const [loading, setLoading] = useState(false);

    const adjustTimeValues = (timeStr: string, isEndTime: boolean = false) => {
        if (!timeStr || timeStr === "00:00") {
            return isEndTime ? "23:59:00" : "00:00:00";
        }
        return `${timeStr}:00`;
    };

    const currency = DD?.currency || pageData?.currency || 'PBU'
    const userName = pageData?.user_name || userData?.user_name || ''
    const pageRows = Array.isArray(pageData?.rows) ? pageData.rows : []
    const displayTotal = round2(Number(pageData?.total) || 0)
    const totalPages = pageData?.totalPages || 1
    
    const {
        currentPage: paginationPage,
        setCurrent: setPaginationPage,
        visiblePages,
        handlePageClick,
    } = usePagination({
        totalPages: totalPages,
        currentPage: page,
        onPageChange: (newPage) => {
            setPage(newPage);
            getPageData(filterTab, currentTab, startDate, endDate, newPage, sportFilter, {
                startDate,
                endDate,
                startTime,
                endTime,
            });
        },
    });
    
    const currentPage = Math.min(paginationPage, totalPages)

    useEffect(() => {
        setPaginationPage(1)
        setPage(1)
        setSportFilter('ALL')
        getPageData(filterTab, currentTab, startDate, endDate, 1, 'ALL', {
            startDate,
            endDate,
            startTime,
            endTime,
        })
    }, [currentTab, userId])

    const getPageData = async (
        FilterType: string = filterTab,
        BET_TYPE: string = currentTab,
        FROM: Date = startDate,
        TO: Date = endDate,
        PAGE: number = 1,
        SPORT: string = sportFilter,
        overrideDates?: { startDate: Date, endDate: Date, startTime: string, endTime: string }
    ) => {
        setLoading(true);
        setOpenRows([]);

        const useStartDate = overrideDates?.startDate || FROM;
        const useEndDate = overrideDates?.endDate || TO;
        const useStartTime = overrideDates?.startTime || startTime;
        const useEndTime = overrideDates?.endTime || endTime;

        const finalStartTime = adjustTimeValues(useStartTime, false);
        const finalEndTime = adjustTimeValues(useEndTime, true);

        const fromDate = new Date(useStartDate);
        const toDate = new Date(useEndDate);
        if (FilterType === "date") {
            const fromClock = finalStartTime.split(":").map((n: string) => parseInt(n, 10) || 0);
            const toClock = finalEndTime.split(":").map((n: string) => parseInt(n, 10) || 0);
            fromDate.setHours(fromClock[0], fromClock[1], fromClock[2] || 0, 0);
            toDate.setHours(toClock[0], toClock[1], toClock[2] || 0, 0);
        }

        const data: any = {
            api: profitLossApi,
            value: {
                id: userId ? userId : userData._id,
                betType: BET_TYPE,
                filter: FilterType || 'date',
                from: fromDate.toISOString(),
                to: toDate.toISOString(),
                page: PAGE,
                limit: PAGE_SIZE,
                sport: SPORT || 'ALL',
            },
        }
        await postApi(data).then(function (response) {
            const payload = response?.data?.data
            if (Array.isArray(payload)) {
                setPageData({ rows: payload, total: payload.length, totalPages: 1 })
            } else {
                const rows = Array.isArray(payload?.rows) ? payload.rows : []
                setPageData({
                    rows,
                    total: payload?.total ?? 0,
                    user_name: payload?.user_name || '',
                    currency: payload?.currency || '',
                    totalPages: payload?.totalPages || 1,
                })
            }
        }).catch(err => {
            setPageData({ rows: [], total: 0, totalPages: 1 })
            if (err.response?.data?.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const onTabChange = (TAB: string) => {
        setCurrentTab(TAB)
        setPaginationPage(1)
        setPage(1)
    }

    const setPeriodToday = () => {
        const from = startOfDay(new Date())
        const to = new Date()

        const now = new Date()
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const currentTime = `${hours}:${minutes}`

        setStartDate(from)
        setEndDate(to)
        setStartTime("00:00")
        setEndTime(currentTime)
        setFilterTab('today')
        setPaginationPage(1)
        setPage(1)
        getPageData('today', currentTab, from, to, 1, sportFilter, {
            startDate: from,
            endDate: to,
            startTime: "00:00",
            endTime: currentTime
        })
    }

    const setPeriodYesterday = () => {
        const from = daysAgo(1)
        const to = new Date()
        const now = new Date()
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const currentTime = `${hours}:${minutes}`

        setStartDate(from)
        setEndDate(to)
        setStartTime("00:00")
        setEndTime(currentTime)
        setFilterTab('date')
        setPaginationPage(1)
        setPage(1)
        getPageData('date', currentTab, from, to, 1, sportFilter, {
            startDate: from,
            endDate: to,
            startTime: "00:00",
            endTime: currentTime
        })
    }

    const getPL = () => {
        // Adjust times before validation
        const finalStartTime = adjustTimeValues(startTime, false);
        const finalEndTime = adjustTimeValues(endTime, true);

        // Add time to dates for validation
        const startDateTime = moment(startDate).set({ hour: parseInt(finalStartTime.split(':')[0]), minute: parseInt(finalStartTime.split(':')[1]), second: parseInt(finalStartTime.split(':')[2] || '0') });
        const endDateTime = moment(endDate).set({ hour: parseInt(finalEndTime.split(':')[0]), minute: parseInt(finalEndTime.split(':')[1]), second: parseInt(finalEndTime.split(':')[2] || '0') });

        // Validate date range
        const daysDiff = moment(endDate).diff(moment(startDate), 'days');

        if (daysDiff > 31) {
            notifyError("Date range cannot exceed 31 days");
            return;
        }

        // Validate full datetime (date + time)
        if (startDateTime.isAfter(endDateTime)) {
            notifyError("Start date/time cannot be after end date/time");
            return;
        }

        if (startDateTime.isSame(endDateTime)) {
            notifyError("Start date/time cannot be the same as end date/time");
            return;
        }

        setFilterTab('date')
        setPaginationPage(1)
        setPage(1)
        getPageData('date', currentTab, startDate, endDate, 1, sportFilter, {
            startDate,
            endDate,
            startTime,
            endTime,
        })
    }



    const formatAmt = (n: number) => {
        const v = Number(n) || 0
        return v.toFixed(2)
    }

    const formatStake = (n: number) => {
        const v = Number(n) || 0
        return Number.isInteger(v) ? String(v) : v.toFixed(2)
    }

    const formatOdds = (value: any) => {
        if (value == null || value === '') return '--'
        const n = Number(value)
        if (!Number.isFinite(n)) return String(value)
        return n.toFixed(2)
    }

    const formatSide = (side: any) => {
        const text = String(side || '').trim()
        if (!text) return '--'
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    }

    const formatPL = (n: number) => `(${formatAmt(n)})`

    const plClass = (n: number) => (Number(n) >= 0 ? 'text-green' : 'text-danger')

    const sumClass = (n: number) => (Number(n) > 0 ? 'text-green' : 'text-danger')

    const marketParts = (item: any) => {
        if (item.eventName || item.sport) {
            return {
                sport: item.sport || capSport(item.sportType || ''),
                event: item.eventName || '',
                market: item.marketName || '',
                run: item.runValue || '',
            }
        }
        const parts = String(item.market || '').split(/\s*>\s*/)
        return { sport: parts[0] || '', event: parts[1] || '', market: parts.slice(2).join(' > '), run: item.runValue || '' }
    }



    return (
        <>
            <div className='account_tabs_r_bet_content'>
                <h2 className='mb-15'>
                    <strong>Betting Profit &amp; Loss : Main wallet</strong>
                </h2>
                {userName ? (
                    <p className="profile-username">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14"><path fill="currentColor" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" /></svg>
                        <span>{userName}</span>
                    </p>
                ) : null}

                <ul className="nav nav-tabs" role="tablist">
                    {PRIMARY_TABS.map((t) => (
                        <li className="nav-item" key={t.key}>
                            <a className={`${currentTab === t.key ? "active" : ""} nav-link `} onClick={() => onTabChange(t.key)}>{t.label}</a>
                        </li>
                    ))}
                    {SECONDARY_TABS.map((t) => (
                        <li className="nav-item" key={t.key}>
                            <a className={`${currentTab === t.key ? "active" : ""} nav-link `} onClick={() => onTabChange(t.key)}>{t.label}</a>
                        </li>
                    ))}
                </ul>
                <div className="function-wrap light-grey-bg">
                    <ul className="inputlist">
                        <li><label>Period</label></li>
                        <li>
                            <input name="from_date" className="form-control1 hasDatepicker pnl-datetime" type="date" value={moment(startDate).format('YYYY-MM-DD')} style={{ height: '25px', borderRadius: '4px', padding: '0 5px' }} onChange={(e: any) => { const newDate = e?.target?.value ? new Date(e.target.value) : new Date(); setStartDate(newDate); setFilterTab('date'); }} />
                            <input name="from_time" className="form-control1" type="text" placeholder="HH:MM" value={startTime} maxLength={5} style={{ width: '45px', height: '25px', borderRadius: '4px', padding: '0 5px' }} onChange={(e:any)=> {
                                const value = e.target.value.replace(/[^0-9:]/g, '');
                                const parts = value.split(':');
                                if (parts.length > 2) return;
                                if (parts[0] && parseInt(parts[0]) > 23) return;
                                if (parts[1] && parseInt(parts[1]) > 59) return;
                                setStartTime(value);
                                setFilterTab('date');
                            }} />
                            <span> to </span>
                            <input name="to_date" className="form-control1 hasDatepicker pnl-datetime" type="date" value={moment(endDate).format('YYYY-MM-DD')} style={{ height: '25px', borderRadius: '4px', padding: '0 5px' }} onChange={(e: any) => { setEndDate(e?.target?.value ? new Date(e.target.value) : new Date()); setFilterTab('date'); }} />
                            <input name="to_time" className="form-control1" type="text" placeholder="HH:MM" value={endTime} maxLength={5} style={{ width: '45px', height: '25px', borderRadius: '4px', padding: '0 5px' }} onChange={(e:any)=> {
                                const value = e.target.value.replace(/[^0-9:]/g, '');
                                const parts = value.split(':');
                                if (parts.length > 2) return;
                                if (parts[0] && parseInt(parts[0]) > 23) return;
                                if (parts[1] && parseInt(parts[1]) > 59) return;
                                setEndTime(value);
                                setFilterTab('date');
                            }} />
                        </li>
                    </ul>
                    <ul className="inputlist history-filter-btns">
                        <li style={{ marginRight: '2px' }} onClick={setPeriodToday}><a className="text-decoration-none btn btn-default-customize cursor-pointer">Just For Today</a></li>
                        <li style={{ marginRight: '2px' }} onClick={setPeriodYesterday}><a className="text-decoration-none btn btn-default-customize cursor-pointer">From Yesterday</a></li>
                        <li style={{ marginRight: '2px' }} onClick={getPL}><a className="text-decoration-none btn btn-default-customize cursor-pointer">Get P &amp; L</a></li>
                        <li style={{ marginRight: '2px' }}></li>
                    </ul>
                </div>
                <p style={{ marginBottom: "2px" }}>Betting Profit &amp; Loss enables you to review the bets you have placed.</p>
                <p style={{ marginBottom: "7px" }}>Specify the time period during which your bets were placed, the type of markets on which the bets were placed, and the sport.</p>
                <p style={{ marginBottom: "7px" }}>Betting Profit & Loss is available online for the past 30 days.</p>

                <div className={`pnl-total-bar ${displayTotal >= 0 ? 'is-profit' : 'is-loss'}`}>
                    <div>Total P/L: {currency} {formatPL(displayTotal)}</div>
                    <div className="pnl-total-bar-right">
                        <select
                            id="plSelect"
                            className="pnl-sport-filter"
                            value={sportFilter}
                            onChange={(e) => {
                                const nextSport = e.target.value
                                setSportFilter(nextSport)
                                setPaginationPage(1)
                                setPage(1)
                                getPageData(filterTab, currentTab, startDate, endDate, 1, nextSport, {
                                    startDate,
                                    endDate,
                                    startTime,
                                    endTime,
                                })
                            }}
                        >
                            {SPORT_FILTERS.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <span style={{ marginBottom: "5px" }}>{currency} {formatPL(displayTotal)}</span>
                    </div>
                </div>

                <div className="table-responsive">
                    <table style={{ marginBottom: "8px" }} id="ProfitLossTable" className="table01 margin-table pnl-table">
                        <thead>
                            <tr>
                                <th className="col-market">Market</th>
                                <th className="col-date">Settled date</th>
                                <th className="col-pl">Profit/Loss</th>
                            </tr>
                        </thead>
                        {loading ? (
                            <tbody>
                                <tr>
                                    <td colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
                                        <InPageLoader />
                                    </td>
                                </tr>
                            </tbody>
                        ) : pageRows.length > 0 ? (
                            <tbody>
                                {pageRows.map((item: any, i: number) => {
                                    const parts = marketParts(item)
                                    const rowKey = `${item.market}-${i}`
                                    const opened = openRows.includes(rowKey)

                                    // Transform betType: show "Fancy" if betType is "session"
                                    const displayMarket = parts.market
                                        ? String(parts.market).toLowerCase() === "session"
                                            ? "Fancy"
                                            : parts.market
                                        : parts.market

                                    const isPremiumTab = currentTab === "premium"

                                    return (
                                        <React.Fragment key={rowKey}>
                                            <tr>
                                                <td className="col-market">
                                                    {parts.sport ? <span className="pnl-sport">{parts.sport}</span> : null}
                                                    {parts.event ? <><span className="pnl-chev">&#9654;</span><span className="pnl-event">{parts.event}</span></> : null}
                                                    {displayMarket ? <><span className="pnl-chev">&#9654;</span><span className="pnl-mkt">{displayMarket}</span></> : null}
                                                    {parts.run ? <><span className="pnl-chev">&#9654;</span><span className="pnl-run">{parts.run}</span></> : null}
                                                </td>
                                                <td className="col-date">{item.settledDate ? moment(item.settledDate).format('YYYY-MM-DD HH:mm:ss') : '--'}</td>
                                                <td className={`col-pl ${plClass(item.profitLoss)}`}>
                                                    {formatPL(item.profitLoss)}
                                                    <a className="pnl-plus" onClick={() => setOpenRows((prev) => prev.includes(rowKey) ? prev.filter((key) => key !== rowKey) : [...prev, rowKey])}>{opened ? '-' : '+'}</a>
                                                </td>
                                            </tr>
                                            {opened && Array.isArray(item.bets) && item.bets.length > 0 ? (
                                                <tr className="pnl-detail">
                                                    <td colSpan={3}>
                                                        <BetBreakdown
                                                            bets={item.bets}
                                                            netMarketTotal={Number(item.profitLoss) || 0}
                                                            userName={userName}
                                                            isPremiumTab={isPremiumTab}
                                                            formatAmt={formatAmt}
                                                            formatStake={formatStake}
                                                            formatOdds={formatOdds}
                                                            formatSide={formatSide}
                                                            formatPL={formatPL}
                                                            plClass={plClass}
                                                            sumClass={sumClass}
                                                        />
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </React.Fragment>
                                    )
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={3}>
                                        <p>You have no bets in this time period.</p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    <p style={{ marginBottom: "2px" }}>Profit and Loss is shown net of commission.</p>
                </div>

                <div>
                    <Pagination 
                        currentPage={currentPage}
                        totalPages={totalPages}
                        visiblePages={visiblePages}
                        handlePageClick={handlePageClick}
                        colorSchema={DD?.colorSchema}
                    />
                </div>
            </div>
        </>
    )
}

function BetBreakdown(props: {
    bets: any[]
    netMarketTotal: number
    userName: string
    isPremiumTab: boolean
    formatAmt: (n: number) => string
    formatStake: (n: number) => string
    formatOdds: (value: any) => string
    formatSide: (side: any) => string
    formatPL: (n: number) => string
    plClass: (n: number) => string
    sumClass: (n: number) => string
}) {
    const {
        bets,
        netMarketTotal,
        userName,
        isPremiumTab,
        formatAmt,
        formatStake,
        formatOdds,
        formatSide,
        formatPL,
        plClass,
        sumClass,
    } = props

    let totalStakes = 0
    let backSubtotal = 0
    let laySubtotal = 0
    for (const bet of bets) {
        totalStakes += Number(bet?.stake) || 0
        const side = String(bet?.betSide || '').toLowerCase()
        const pl = Number(bet?.profitLoss) || 0
        const isBack = side === 'back' || side === 'yes'
        if (bet?.backSubtotal != null || bet?.laySubtotal != null) {
            backSubtotal += Number(bet.backSubtotal) || 0
            laySubtotal += Number(bet.laySubtotal) || 0
        } else if (isBack) {
            backSubtotal += pl
        } else {
            laySubtotal += pl
        }
    }
    const marketSubtotal = round2(backSubtotal + laySubtotal)
    const net = round2(netMarketTotal)
    const commission = round2(marketSubtotal - net)
    const placedSample = (() => {
        const bet = bets.find((row) => row?.betPlaced)
        return bet ? moment(bet.betPlaced).format('ddd MMM DD HH:mm:ss') : 'Thu Oct 15 00:00:00'
    })()

    const sumLine = (label: string, amount: string, amountClass: string, isNet = false) => (
        <tr className={isNet ? 'pnl-sum-row pnl-sum-net' : 'pnl-sum-row'}>
            <td colSpan={6} />
            <td className="sum-merge" colSpan={2}>
                <div className="sum-anchor">
                    <span className="sum-sizer">{placedSample}</span>
                    <span className={amountClass}>{amount}</span>
                    <span className="sum-label">{label}</span>
                </div>
            </td>
        </tr>
    )

    return (
        <table className="pnl-bets">
            <colgroup>
                <col className="c-user" />
                <col className="c-bet" />
                <col className="c-sel" />
                <col className="c-odds" />
                <col className="c-stake" />
                <col className="c-type" />
                <col className="c-placed" />
                <col className="c-pl" />
            </colgroup>
            <thead>
                <tr>
                    <th>Userid</th>
                    <th>Bet ID</th>
                    <th>Selection</th>
                    <th className="num">Odds</th>
                    <th className="num">Stake</th>
                    <th>Type</th>
                    <th>Placed</th>
                    <th className="num">Profit/Loss</th>
                </tr>
            </thead>
            <tbody>
                {bets.map((bet: any, bi: number) => {
                    const displaySelection = isPremiumTab
                        ? bet?.subSelection || bet?.selection || '--'
                        : bet?.selection || '--'
                    const placed = bet?.betPlaced ? moment(bet.betPlaced) : null
                    const oddsText = bet?.runValue ? String(bet.runValue) : formatOdds(bet?.oddsUp)

                    return (
                        <tr key={bet?.betId || bi}>
                            <td>{bet?.userName || userName || '--'}</td>
                            <td>{bet?.betId || '--'}</td>
                            <td>{displaySelection}</td>
                            <td className="num">{oddsText}</td>
                            <td className="num">{formatStake(bet?.stake)}</td>
                            <td>{formatSide(bet?.betSide)}</td>
                            <td className="placed">
                                {placed ? (
                                    <span className="placed-block">
                                        {placed.format('ddd MMM DD HH:mm:ss')}
                                        <span className="placed-tz">IST {placed.format('YYYY')}</span>
                                    </span>
                                ) : '--'}
                            </td>
                            <td className={`num ${plClass(bet?.profitLoss)}`}>{formatPL(bet?.profitLoss)}</td>
                        </tr>
                    )
                })}
            </tbody>
            <tfoot>
                {sumLine('Total Stakes', formatAmt(totalStakes), 'sum-amt stake')}
                {sumLine('Back subtotal', formatPL(backSubtotal), `sum-amt ${sumClass(backSubtotal)}`)}
                {sumLine('Lay subtotal', formatPL(laySubtotal), `sum-amt ${sumClass(laySubtotal)}`)}
                {sumLine('Market subtotal', formatPL(marketSubtotal), `sum-amt ${sumClass(marketSubtotal)}`)}
                {sumLine('Commission', formatPL(commission), `sum-amt ${sumClass(commission)}`)}
                {sumLine('Net Market Total', formatPL(net), `sum-amt ${sumClass(net)}`, true)}
            </tfoot>
        </table>
    )
}

function capSport(value: string) {
    if (!value) return value
    return value.charAt(0).toUpperCase() + value.slice(1)
}

function round2(n: number) {
    return Number((Number(n) || 0).toFixed(2))
}

export default BettingProfitLoss
